module.exports = __webpack_public_path__ + "b0631662058654f2af634d502a76ed57.svg";